import { TargetComparison, type Target } from '../../../../../api/targets-client/targets-client.type';
import { TimeAllocationType } from '../../../../../api/work-periods-client/work-periods-client.type';
import type { DataPoint } from '../../../../../store/process-analysis-store/process-analysis-store.type';

/**
 * Generates initial data for the target modal based on a process analysis data point
 *
 * @param {DataPoint | null} dataPoint - The data point to generate initial data from
 * @returns {Partial<Target>} The initial data for the target modal
 */
export const getTargetModalInitialData = (dataPoint: DataPoint | null): Partial<Target> => {
  const defaultData: Partial<Target> = {
    time_allocation_type: TimeAllocationType.BiWeekly,
    target_comparison: TargetComparison.EQ,
    use_transform: true,
  };

  if (!dataPoint) {
    return defaultData;
  }

  return {
    ...defaultData,
    measure: dataPoint.measure,
    start_date: dataPoint.rawDate || undefined,
  };
};
